// Display formatting shared by the dashboard's server and client components.

/** Compact token/request counts: 1284 -> "1.3k", 2_400_000 -> "2.4M". */
export function compact(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(1)}B`;
  if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return `${Math.round(n)}`;
}

/**
 * Money for display. Small amounts keep cents; larger ones drop to whole
 * dollars so a hero figure doesn't read as a receipt.
 */
export function usd(n: number, { compactAbove = 10_000 } = {}): string {
  if (Math.abs(n) >= compactAbove) return `$${compact(n)}`;
  if (Math.abs(n) >= 100) return `$${Math.round(n).toLocaleString()}`;
  return `$${n.toFixed(2)}`;
}

/** "3m ago" / "in 2h". Past and future both read naturally. */
export function relativeTime(ts: number, now: number = Date.now()): string {
  const diff = ts - now;
  const future = diff > 0;
  const mins = Math.round(Math.abs(diff) / 60_000);
  const label =
    mins < 1
      ? "now"
      : mins < 60
        ? `${mins}m`
        : mins < 1440
          ? `${Math.round(mins / 60)}h`
          : mins < 43_200
            ? `${Math.round(mins / 1440)}d`
            : `${Math.round(mins / 43_200)}mo`;
  if (label === "now") return future ? "in a moment" : "just now";
  return future ? `in ${label}` : `${label} ago`;
}

/** Short window name for a limit bar with no more specific label. */
export const WINDOW_LABELS: Record<string, string> = {
  "5h": "5-hour window",
  weekly: "Weekly",
  monthly: "Monthly",
};
